"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getTabs = exports.ExtraPreLoader = exports.Extras = void 0;
var react_1 = __importStar(require("react"));
var utils_1 = __importDefault(require("@nexys/utils"));
var cell_1 = require("../../ui/cell");
var load_1 = require("../../data/load");
var utils_2 = require("../../utils");
var useStyles = utils_2.makeStyles(function (theme) { return ({
    loaderWrapper: {
        padding: theme.spacing(4, 0)
    }
}); });
exports.Extras = function (props) { return (react_1["default"].createElement(react_1["default"].Fragment, null, props.extras.map(function (unit, i) {
    if (!unit.Component) {
        return null;
    }
    var component = unit.Component(props.uuid, props.data);
    if (!component) {
        return null;
    }
    return (react_1["default"].createElement(cell_1.Cell, __assign({ key: i, title: unit.title }, unit.width, { PaperComponent: props.PaperComponent, withPaper: unit.paper !== undefined ? unit.paper : props.withPaper }), component));
}))); };
exports.ExtraPreLoader = function (p) {
    var uuid = p.uuid, dataLoad = p.dataLoad, NoDataComponent = p.NoDataComponent;
    var innerDataLoad = react_1.useState(dataLoad(uuid))[0];
    var classes = useStyles();
    return (react_1["default"].createElement(load_1.WithLoader, { Component: exports.Extras, uuid: p.uuid, extras: p.extras, dataLoad: innerDataLoad, noDataMessage: p.noDataMessage, NoDataComponent: NoDataComponent
            ? function (_a) {
                var error = _a.error;
                return react_1["default"].createElement(NoDataComponent, { error: error });
            }
            : undefined, PaperComponent: p.PaperComponent, withPaper: p.withPaper, LoaderWrapperComponent: function (_a) {
            var children = _a.children;
            return (react_1["default"].createElement(cell_1.Cell, { xs: 12, sm: 12, md: 12, lg: 12, xl: 12, classNames: { paper: classes.loaderWrapper }, withPaper: p.withPaper }, children));
        } }));
};
exports.getTabs = function (extras) {
    var empty = [];
    if (!extras || extras.length === 0) {
        return [['null', empty]];
    }
    var g = utils_1["default"].ds.groupBy(extras, 'tab');
    if (!g['null']) {
        g['null'] = empty;
    }
    return Object.entries(g);
};
